import qz from "qz-tray";
import { AppDispatch } from "../../../store/store";
import {
  setConnecting,
  setConnectionState,
} from "../../../store/slices/qztray/qzTrayClientSlice";

/**
 * 🚀 connectClientLogic
 *
 * Conecta con QZ Tray configurando certificado público
 * y firma remota antes de abrir el WebSocket.
 */
export const connectClientLogic = async (
  dispatch: AppDispatch,
  config: any,
  handle: (err: any) => void,
  showAlert: (type: string, title: string, msg: string) => void,
  sign: (toSign: string) => Promise<string>
): Promise<boolean> => {
  if (!config) return false;

  const { host, port, sslEnabled, certificateContent } = config;
  const protocol = sslEnabled ? "wss" : "ws";
  const endpoint = `${protocol}://${host}:${port}`;

  try {
    if (qz.websocket.isActive()) {
      dispatch(setConnectionState({ isConnected: true, endpoint }));
      return true;
    }

    dispatch(setConnecting(true));

    const cert = certificateContent?.trim();

    if (!cert) {
      throw new Error("No se recibió el certificado público requerido por QZ Tray.");
    }

    // ======================================================
    // 🔐 Certificado público
    // ======================================================
    qz.security.setCertificatePromise((resolve, reject) => {
      try {
        resolve(cert);
      } catch (error) {
        reject(error);
      }
    });

    // ======================================================
    // ✍️ Firma remota SHA256
    // ======================================================
    qz.security.setSignatureAlgorithm("SHA256");

    qz.security.setSignaturePromise((toSign) => {
      return (resolve, reject) => {
        sign(toSign)
          .then((signature) => {
            if (!signature || typeof signature !== "string") {
              reject("El backend no devolvió una firma válida.");
              return;
            }

            resolve(signature);
          })
          .catch((error) => reject(error));
      };
    });

    // ======================================================
    // 🌐 Conectar WebSocket
    // ======================================================
    await qz.websocket.connect({ address: endpoint });

    dispatch(setConnectionState({ isConnected: true, endpoint }));
    return true;
  } catch (err: any) {
    console.error("❌ Error al conectar QZ Tray:", err);

    dispatch(setConnectionState({ isConnected: false }));

    handle(err);

    showAlert(
      "error",
      "Error conexión QZ Tray",
      err?.message || "No fue posible conectar con QZ Tray."
    );

    return false;
  } finally {
    dispatch(setConnecting(false));
  }
};